<template>
  <div class="template1">
    <div id="top"></div>
    <img
      id="logo"
      src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Flogo.png?alt=media&token=655cfdd0-4d4b-4334-a218-151bf198356d"
      alt=""
    />
    <GrandDay :code="Code" />
    <InfoEvent :code="Code" />
    <RSVP :code="Code" />
    <div id="botton"></div>
  </div>
</template>

<script>
import GrandDay from "@/components/Template1/GrandDay.vue";
import InfoEvent from "@/components/Template1/InfoEvent.vue";
import RSVP from "@/components/Template1/RSVP.vue";

export default {
  props: {
    Code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      autoplay: 0,
    };
  },
  components: {
    GrandDay,
    InfoEvent,
    RSVP,
  },
  mounted() {
    this.autoplay = 1;
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Gwendolyn&family=Roboto:wght@300&display=swap");

.template1 {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 1rem;
  justify-items: center;
  background-image: url(https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Ffondo-desktop.png?alt=media&token=33e53eff-6fff-4a59-88f8-35219df01465);
  background-repeat: no-repeat;
  background-size: cover;
  font-family: "roboto" !important;
}

#logo {
  width: 20rem;
}

#top {
  height: 10rem;
}

#botton {
  height: 10rem;
}

@media (max-width: 768px) {
  .template1 {
    background-image: url(https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Navidad-skycom%2Ffondo.png?alt=media&token=4eea9e54-876b-4577-9f3f-e9dcbd359a76);
  }

  .template1 > #logo {
    width: 20rem;
  }

  #top {
    height: 8rem;
  }

  #botton {
    height: 10rem;
  }
}
</style>
